import { z } from 'zod';
import i18n from 'src/i18n/i18n';

const EMAIL_REGEX = new RegExp('^[\\w_\\-.+]+@([\\w\\-]+\\.)+[\\w\\-]+$');

type EmailFieldOptions = {
  required?: boolean;
  maxLength?: number;
};

export const emailFieldSchema = (options?: EmailFieldOptions) => {
  const { required = false, maxLength } = options || {};

  const baseString = z
    .string({
      message: i18n.t('validations.required')!,
    })
    .regex(EMAIL_REGEX, i18n.t('validations.email')!);

  if (required) {
    const withMax = maxLength
      ? baseString.max(maxLength, i18n.t('validations.max-length', { maxLength })!)
      : baseString;
    return withMax.min(1, i18n.t('validations.required')!);
  }

  const optionalString = maxLength
    ? baseString.max(maxLength, i18n.t('validations.max-length', { maxLength })!)
    : baseString;

  return z.union([z.literal(''), optionalString]).optional();
};
